import { useEffect, useRef, useState } from 'react'
import classes from './InputWithButton.module.css'

const InputWithButton = ({type, name, required, placeholder, label, buttonIcon, clearInputExtraTask, currentValue, action, identifier, isLoading, foucsExtraTask, blurExtraTask, actionOnKeyUp, keyupExtra, interruptActionOnKeyUpOnEnter, resetSignal}) => {
    const inputRef = useRef(null);
    const buttonRef = useRef(null)


    const [isfocused, setIsFocused] = useState(false)
    const [defaultValue, setDefaultValue] = useState(currentValue ? currentValue : '')

    const foucsHandler = () => {
        setIsFocused(true)

        if (foucsExtraTask) {
            foucsExtraTask()
        }
    }

    const blurHandler = (e) => {
        if (e.target.value == '') {
            setIsFocused(false)
        }
        if (blurExtraTask) {
            blurExtraTask(e)
        }
    }

    const clearInputHandler = () => {
        inputRef.current.value = "";
        setIsFocused(false)
        setDefaultValue("")
        if (clearInputExtraTask) {
            clearInputExtraTask()
        }
    }

    let typingTimer;                //timer identifier
    const doneTypingInterval = 1500;  //time in ms,

    const keyUpFunction = (event) => {
        if (!actionOnKeyUp) {
            return
        }

        if (interruptActionOnKeyUpOnEnter && event.key === 'Enter') {
            clearTimeout(typingTimer)
            return
        }

        clearTimeout(typingTimer)
        typingTimer = setTimeout(doneTyping, doneTypingInterval)
    }

    const doneTyping = () => {
        buttonRef.current?.click()
    }

    const handleKeyDown = (event) => {
        clearTimeout(typingTimer);
        if (event.key == 'Enter') {
            setDefaultValue(event.target.value)
            if (event.target.value && action) {                
                action({
                    data: {
                        value: event.target.value
                    },
                    identifier: identifier
                })
            }
        }
    }

    const keyuphandler = (event) => {
        if (keyupExtra) {
            keyupExtra(event.target.value)
        }
        setDefaultValue(event.target.value)
    }   


    useEffect(() => {
        setDefaultValue(currentValue ? currentValue : '')
        if (currentValue && currentValue != '') {
            setIsFocused(true)
        }
    }, [currentValue])

    useEffect(() => {
        if (resetSignal) {
            if (inputRef.current) inputRef.current.value = ""
            setDefaultValue("")
            setIsFocused(false)
        }
    }, [resetSignal])

    return <div className={classes.input_container}>        
        <button ref={buttonRef} className={classes.input_button} type='submit'><i className={buttonIcon}></i></button>
        <div className={`${classes.input_box_fields} ${isfocused && classes.focused}`}>
            <label htmlFor={name} className={classes.label}>{label}</label>
            <input autoComplete="off" ref={inputRef} className={classes.input} type={type} name={name} id={name} required={required} placeholder={placeholder} onFocus={foucsHandler} onBlur={blurHandler} onKeyDown={handleKeyDown} value={defaultValue} onChange={keyuphandler} onKeyUp={keyUpFunction}/>

            {!isLoading &&<button className={classes.clear_input} type='button' onClick={clearInputHandler}>
                <i className='ti ti-x'></i>
                <span className='sr-only'>clear input</span>
            </button>}
            {isLoading && <span className={`loader dark ${classes.loader_input}`}></span>}
        </div>
        
    </div>
}

export default InputWithButton